module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-2bfffa4c39c2d84362396a4a8e8c7aca.png";